import React from "react";

const OurTeam = () => {
  return <div>ourTeam</div>;
};

export default OurTeam;
